import { useNavigate } from 'react-router-dom';

import { IProperty } from '../../data/entities/property';
import { sendCustomFullStoryEvent } from '../../plugins';
import { IGradientInfoCardProps } from '../../view/components/gradient-info-card/GradientInfoCardWithImage';

type PromoCardDataObj = IGradientInfoCardProps;

export const usePromoCards = (properties: IProperty[]) => {
	const navigate = useNavigate();

	const activeProperties = properties?.filter((property) => property.is_active);

	const newestActiveProperty = activeProperties?.sort((a, b) =>
		a.id > b.id ? -1 : 1
	)?.[0];

	const promoCardData: PromoCardDataObj[] = [
		{
			title: 'Smart pricing',
			description:
				'Set your own rates, or let us do it for you with Smart Pricing.',
			image: 'calendar',
			colour: 'green',
			buttonText: 'Go to pricing',
			buttonVariant: 'positive',
			onClick: () => {
				if (!newestActiveProperty) {
					console.error('No properties found');
				} else {
					sendCustomFullStoryEvent(
						'smart_pricing_homepage_card_button_clicked',
						{
							property_id: newestActiveProperty.id,
						}
					);
					navigate(
						`/property/${newestActiveProperty.id}/${!newestActiveProperty.published_version ? 'add' : 'edit'
						}/tasks/pricing`
					);
				}
			},
		},
		{
			title: 'Direct booking',
			description:
				'Promote and receive guest bookings through your very own unique web page.',
			image: 'website',
			colour: 'blue',
			buttonText: 'Go to direct',
			buttonVariant: 'primary',
			onClick: () => {
				sendCustomFullStoryEvent(
					'direct_homepage_card_button_clicked',
					{}
				);
				window.location.assign(`${window.location.origin}/direct`);
			},
		},
	];

	return promoCardData;
};
